import { loadScript } from './loadScript.js';

if (!HTMLElement.prototype.addTapEvent) {
    HTMLElement.prototype.addTapEvent = function (callback) {
        var tapStartTime = 0,
            tapEndTime = 0,
            tapTime = 500, //tap等待时间，在此事件下松开可触发方法
            tapStartClientX = 0,
            tapStartClientY = 0,
            tapEndClientX = 0,
            tapEndClientY = 0,
            tapScollHeight = 15, //水平或垂直方向移动超过15px测判定为取消（根据chrome浏览器默认的判断取消点击的移动量)
            cancleClick = false;
        this.addEventListener('touchstart', function () {
            tapStartTime = event.timeStamp;
            var touch = event.changedTouches[0];
            tapStartClientX = touch.clientX;
            tapStartClientY = touch.clientY;
            cancleClick = false;
        });
        this.addEventListener('touchmove', function () {
            var touch = event.changedTouches[0];
            tapEndClientX = touch.clientX;
            tapEndClientY = touch.clientY;
            if (
                Math.abs(tapEndClientX - tapStartClientX) > tapScollHeight ||
                Math.abs(tapEndClientY - tapStartClientY) > tapScollHeight
            ) {
                cancleClick = true;
            }
        });
        this.addEventListener('touchend', function (e) {
            tapEndTime = event.timeStamp;
            if (!cancleClick && tapEndTime - tapStartTime <= tapTime) {
                callback(e);
            }
        });
    };
}

function _has_class(elem, class_name) {
    if (new RegExp(class_name, 'g').test(elem.className)) {
        return true;
    }
    return false;
}

function _bubble(elem, condition, callBack) {
    var con = false;
    do {
        if (condition(elem)) {
            con = true;
            break;
        } else {
            elem = elem.parentNode;
        }
    } while (elem.parentNode);
    con && callBack(elem);
}

function Tracker(event, action) {
    var self = this;
    var _event = event || 'no';
    self.event = _event;
    loadScript('https://s22.cnzz.com/z_stat.php?id=1271358457&web_id=1271358457', function () {
        if (action) {
            try {
                /*eslint no-undef: 1 */
                _czc.push(['_trackEvent', _event, action]);
            } catch (e) {
                console.log(e);
            }
        }
        document.body.addTapEvent(function (e) {
            _bubble(
                e.target,
                function (elem) {
                    if (_has_class(elem, 'jstracker')) {
                        return true;
                    }
                },
                function (elem) {
                    var paramstr = elem.getAttribute('param');
                    var param = new Function('return' + paramstr)();
                    self.track(param.event || _event, param.action);
                }
            );
        });
    });
}

Tracker.prototype.track = function (event, action) {
    var self = this;
    try {
        if (arguments.length === 2) {
            _czc.push(['_trackEvent', event, action]);
        } else {
            _czc.push(['_trackEvent', self.event, arguments[0]]);
        }
    } catch (e) {
        console.log(e);
    }
};

export { Tracker };
